import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, unref as _unref, createSlots as _createSlots, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bece3da"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pa-8 pb-4"
}
const _hoisted_2 = { class: "d-flex justify-space-between align-center" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "d-flex align-center color-modal-title" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "d-flex align-center color-modal-title" }
const _hoisted_7 = { class: "flex-grow-1 d-flex justify-end" }
const _hoisted_8 = {
  key: 1,
  class: "d-flex justify-end pa-4 rounded-xl",
  style: {"gap":"16px"}
}

import { withDefaults, ref, watch } from 'vue';
import { AtomButton, SearchIcon, SolicityIcon } from '@/components/atoms';
interface IProps {
  show: any;
  disabled?: boolean;
  width?: string;
  heigth?: string;
  icon?: string;
  iconColor?: string;
  el?: any;
  title: string;
  subtitle?: string;
  btnCloseText?: string;
  btnConfirmText?: string;
  paddingY?: string;
  btnConfitmDisabled?: boolean;
  hasBtnClose?: boolean;
  hasBtnConfirm?: boolean;
  showFooter?: boolean;
  persistent?: boolean;
  showHeader?: boolean;
  closeBody?: boolean;
  boldTitle?: boolean;
  isRelatory?: boolean;
  isService?: boolean;
  fullWidthButtons?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeModal',
  props: {
    show: {},
    disabled: { type: Boolean, default: false },
    width: { default: '477px' },
    heigth: {},
    icon: {},
    iconColor: {},
    el: { default: 'div' },
    title: {},
    subtitle: {},
    btnCloseText: { default: 'Cancelar' },
    btnConfirmText: { default: 'Importar' },
    paddingY: { default: '0px' },
    btnConfitmDisabled: { type: Boolean },
    hasBtnClose: { type: Boolean, default: true },
    hasBtnConfirm: { type: Boolean, default: true },
    showFooter: { type: Boolean, default: true },
    persistent: { type: Boolean, default: true },
    showHeader: { type: Boolean, default: true },
    closeBody: { type: Boolean, default: false },
    boldTitle: { type: Boolean, default: false },
    isRelatory: { type: Boolean, default: false },
    isService: { type: Boolean, default: false },
    fullWidthButtons: { type: Boolean, default: false }
  },
  emits: ['handleCancel', 'handleConfirm'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const dialog = ref<boolean>(props.show);

function handleCancel() {
  emit('handleCancel');
}
function handleConfirm() {
  emit('handleConfirm');
}

function close() {
  emit('handleCancel', 'fecha');
}

watch(
  () => props.show,
  () => (dialog.value = props.show)
);
watch(
  () => dialog.value,
  (nvalue) => {
    if (!nvalue) emit('handleCancel', dialog.value);
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
    persistent: props.persistent,
    width: props.width,
    height: props.heigth,
    class: "area-modal"
  }, {
    default: _withCtx(() => [
      (_ctx.showHeader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.boldTitle)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.title), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.title), 1)
                  ])),
              _createElementVNode("div", _hoisted_7, [
                _renderSlot(_ctx.$slots, "header")
              ]),
              _createVNode(_component_v_btn, {
                variant: "plain",
                icon: "",
                size: "x-large",
                onClick: close,
                class: "ma-0 w-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-close")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            (!_ctx.isService)
              ? (_openBlock(), _createBlock(_component_v_divider, {
                  key: 0,
                  class: "mt-2"
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_resolveDynamicComponent(props.el), null, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "body-modal px-8",
            style: _normalizeStyle({ padding: `${props.paddingY ? props.paddingY : '0'} 32px` })
          }, [
            _renderSlot(_ctx.$slots, "body"),
            (_ctx.showFooter && !_ctx.isService)
              ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
              : _createCommentVNode("", true),
            (_ctx.showFooter)
              ? (_openBlock(), _createElementBlock("footer", _hoisted_8, [
                  (!_ctx.disabled && _ctx.hasBtnClose)
                    ? (_openBlock(), _createBlock(_unref(AtomButton), {
                        key: 0,
                        classes: "btn-cancel",
                        text: _ctx.btnCloseText,
                        onClick: handleCancel,
                        "button-width": props.fullWidthButtons ? '100%' : '14rem'
                      }, null, 8, ["text", "button-width"]))
                    : _createCommentVNode("", true),
                  (!_ctx.disabled && _ctx.hasBtnConfirm)
                    ? (_openBlock(), _createBlock(_unref(AtomButton), {
                        key: 1,
                        onClickCapture: handleConfirm,
                        classes: "btn-confirm",
                        "button-width": props.fullWidthButtons ? '100%' : '14rem',
                        "prepend-icon": true,
                        text: _ctx.btnConfirmText,
                        type: "submit"
                      }, _createSlots({ _: 2 }, [
                        (_ctx.isRelatory)
                          ? {
                              name: "prependIcon",
                              fn: _withCtx(() => [
                                _createVNode(_unref(SearchIcon))
                              ]),
                              key: "0"
                            }
                          : (!_ctx.isService)
                            ? {
                                name: "prependIcon",
                                fn: _withCtx(() => [
                                  _createVNode(_unref(SolicityIcon))
                                ]),
                                key: "1"
                              }
                            : undefined
                      ]), 1032, ["button-width", "text"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 4)
        ]),
        _: 3
      }))
    ]),
    _: 3
  }, 8, ["modelValue", "persistent", "width", "height"]))
}
}

})